module.exports = "<app-navbar></app-navbar>\n<div class=\"container\">\n    <!--flash-messages></flash-messages-->\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/clientpanel/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main